import dayjs, { extend } from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

extend(utc);
extend(relativeTime);

export function daysFromNow(date: string): string {
  if (date && date.length && date.charAt(date.length - 1) !== 'Z') {
    // Convert to UTC in JS format
    date = date.replace(' ', 'T') + '+00:00';
  }

  return dayjs(date).fromNow();
}

export function simpleDate(date: string, format = 'YYYY-MM-DD h:mma'): string {
  if (!date) {
    const newDate = new Date();
    return dayjs(newDate).format(format);
  } else if (typeof date !== 'number' && date.length && date.charAt(date.length - 1) !== 'Z') {
    // Convert to UTC in JS format
    date = date.replace(' ', 'T') + '+00:00';
  }

  return dayjs(date).format(format);
}

export function relativeTimeFormat(date?: string): string | null {
  if (!date) {
    return null;
  }

  // Convert to UTC in JS format
  if (typeof date !== 'number' && date.charAt(date.length - 1) !== 'Z') {
    date = date.replace(' ', 'T') + '+00:00';
  }

  return dayjs(date).fromNow();
}

export function dayDiff(date: string): number {
  return dayjs(date).diff(new Date(), 'day');
}

export function timeLeft(start: string, finish: string): number {
  if (!start || !finish) {
    return 0;
  }

  const period = dayjs(finish).diff(start, 'day');
  const timeLeft = dayjs(finish).diff(new Date(), 'day');

  // Do some text overriding
  // Round less than one minute up to 1 min
  return timeLeft / period;
}
